// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReturnedCheckOcrDetails
 */
export interface IReturnedCheckOcrDetails {
    /**
     * 
     * @type {string}
     * @memberof IReturnedCheckOcrDetails
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof IReturnedCheckOcrDetails
     */
    check_number?: string;
    /**
     * 
     * @type {number}
     * @memberof IReturnedCheckOcrDetails
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IReturnedCheckOcrDetails
     */
    pay_to?: string;
}

/**
 * Check if a given object implements the IReturnedCheckOcrDetails interface.
 */
export function instanceOfIReturnedCheckOcrDetails(value: object): value is IReturnedCheckOcrDetails {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IReturnedCheckOcrDetailsFromJSON(json: any): IReturnedCheckOcrDetails {
    return IReturnedCheckOcrDetailsFromJSONTyped(json, false);
}

export function IReturnedCheckOcrDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnedCheckOcrDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'check_number': json['check_number'] == null ? undefined : json['check_number'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'pay_to': json['pay_to'] == null ? undefined : json['pay_to'],
    };
}

export function IReturnedCheckOcrDetailsToJSON(json: any): IReturnedCheckOcrDetails {
    return IReturnedCheckOcrDetailsToJSONTyped(json, false);
}

export function IReturnedCheckOcrDetailsToJSONTyped(value?: IReturnedCheckOcrDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'check_number': value['check_number'],
        'amount': value['amount'],
        'pay_to': value['pay_to'],
    };
}

